<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import BackgroundPC from "../assets/img/bacdground_pc.png";
import BackgroundMobile from "../assets/img/background_mobile.png";
import { useClosetStore } from "../stores/closet";
import { useDeviceStore } from "../stores/device";
import { REPORT_HREF_LIST } from '../utils';

const DeviceStore = useDeviceStore()
const ClosetStore = useClosetStore()
const $router = useRouter()
const toPersonal = () => { 
  $router.push(`/closet/${email.value}`)
  ClosetStore.changeFromHomeState(true)
}
const email = ref('')

const textCarouselIndex = ref(true)
const TextModeInterval = ref(null)
const ClotheCount = ref(30000)
onMounted(async () => {
  ClotheCount.value = await ClosetStore.queryClotheCount()
  TextModeInterval.value = setInterval(() => {
    textCarouselIndex.value = !textCarouselIndex.value
  }, 3000)
})
onBeforeUnmount(() => {
  clearInterval(TextModeInterval.value)
})
</script>

<template>
  <main class="view-home">
    <section class="pc-hero" :style="`background-image: url('${DeviceStore.currentMode == 'COMPUTED' ? BackgroundPC : BackgroundMobile}');`">
      <div class="wrapper">
        <h1>衣物處理<span class="font-noto">查</span>詢平台</h1>
        <p>輸入官網註冊Email搜尋</p>
        <p>衣物處理資訊</p>
        <input @keyup.enter="toPersonal" v-model="email" type="text" placeholder="Search...">
      </div>
    </section>

    <section class="text-carousel">
      <Transition>
        <div v-if="textCarouselIndex">
          <p>迄今為止已處理超過</p>
          <h2>{{ ClotheCount }}</h2>
          <p>件</p>
        </div>

        <div v-else>
          <p>為高達</p>
          <h2>79%</h2>
          <p>衣衫延續新生命</p>
        </div>
      </Transition>
    </section>

    <section class="report">
      <div class="wrapper">
        <a v-for="(item, index) in Array(40).fill()" :key="`report_${index}`" :href="REPORT_HREF_LIST[index]" target="_blank">
          <img :src="require(`@/assets/img/report/${index+1}.png`)" alt="">
        </a>
      </div>
      <a href="https://www.twentythree.com.tw/pages/refashion" target="_blank"><h2>Read More ></h2></a>
    </section>
  </main>
</template>

